import React from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";
import {List} from "react-virtualized";
import CheckBox from "../../PageLayout/CheckBox";

const JobBoardFiltersPopupList = (props) => {

  const {renderList, selectEntity, selectedFilter, noEntitiesFound, contentDimensions} = props;

  const listWidth = contentDimensions && contentDimensions.width ? (contentDimensions.width / 2) - 10 : 275; // 10 is padding
  const listHeight = contentDimensions && contentDimensions.height ? contentDimensions.height - 15 - 43 - 37 : 264; // 15 is title, 43 is search, 37 is buttons

  const listSettings = {
    width: listWidth,
    height: listHeight,
    rowHeight: 32,
    overscanRowCount: 6,
    rowCount: renderList.length,
    showScrollingPlaceholder: false,
    useDynamicRowHeight: false,
  }

  const rowRenderer = ({index, key, style}) => {
    const customer = renderList[index];
    return (
      <li className="fc-filters__list-item" style={style} key={key}>
        <CheckBox type="tiny"
                  text={customer}
                  checked={selectedFilter && (selectedFilter.value.includes(customer))}
                  onChecked={() => selectEntity(customer)}
        />
      </li>
    );
  }

  const noRowsRenderer = () => <div className={"ass-list"}><FormattedMessage id={noEntitiesFound}/></div>;

  return (
    <List
      // ref="List"
      className={"fc-filters__list"}
      width={listSettings.width}
      height={listSettings.height}
      overscanRowCount={listSettings.overscanRowCount}
      rowCount={listSettings.rowCount}
      rowHeight={listSettings.rowHeight}
      rowRenderer={rowRenderer}
      noRowsRenderer={noRowsRenderer}
    />
  )
};

JobBoardFiltersPopupList.propTypes = {
  renderList: PropTypes.array.isRequired,
  selectEntity: PropTypes.func.isRequired,
  selectedFilter: PropTypes.object,
  noEntitiesFound: PropTypes.string.isRequired,
  contentDimensions: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
}

export default injectIntl(JobBoardFiltersPopupList)
